
import React from "react";
import useAuth from "../../hooks/useAuth";
import HeaderPrivate from "./Private/HeaderPrivate";
import HeaderPublic from "./Public/HeaderPublic";

const Header = () => {
    const { auth } = useAuth();
    return (<>
        {auth?.user ? <HeaderPrivate /> : <HeaderPublic />}
    </>);

}

export default Header;